<template>
  <div class="flex justify-center mt-20">
    <div class="w-full sm:w-7/12">
      <div name="logo" class="w-5/12 flex">
        <img src="/img/TardiniLogo.svg" />
      </div>
      <div class="p-8 bg-white rounded shadow-xl">
        <form @submit.prevent="resetPassword">
          <div class="mt-4">
            <div class="block text-sm text-gray-00" for="password" :value="__('Password')"></div>
            <input class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" id="password" type="password"
              name="password" placeholder="password" v-model="data.password" required autofocus />
          </div>
          <div class="mt-4">
            <div class="block text-sm text-gray-00" for="password_confirmation" :value="__('Confirm Password')"></div>
            <input class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" id="password_confirmation" type="password"
              name="password_confirmation" placeholder="confirm password" v-model="data.password_confirmation" required
              autofocus />
          </div>
          <div class="flex items-center justify-end mt-4">
            <button class="px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded focus:outline-none">
              {{ __('Reset Password') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        password: undefined,
        password_confirmation: undefined,
        token: this.$route.params.token
      }
    }
  },
  methods: {
    async resetPassword() {
      await this.storeLogTime(async () => {
        let res = await this.handleCallback(() => this.axios.post('/auth/resetpassword', this.data), true);
        if (res)
          this.$router.push({ name: 'login' });
        return res;
      });
    }
  }
}
</script>